enum CompanyTypes {
  MR_COOPER = 'Mr. Cooper',
  DEFAULT = 'Default',
}

export default CompanyTypes;
